import { differenceInDays, formatISO } from 'date-fns';
export function normalizeDate(date) {
  return date ? formatISO(date, {
    representation: 'date'
  }) : null;
}
export function getDaysInRange(range) {
  return range.startDate && range.endDate ? differenceInDays(range.endDate, range.startDate) + 1 // X nights => X + 1 days
  : 0;
}
export function fallbackDuration(daysInRange, defaultDuration) {
  return daysInRange <= 7 ? {
    min: 0,
    max: 0
  } : defaultDuration;
}
const DISPLAY_DURATION_ADDTION = 1;
/*
 * This is a formatter for the duration value.
 * The value is displayed as days, but the internal value is stored as nights.
 * This formatter adds 1 to the displayed value to convert it to days.
 */
export const DurationFormatter = {
  format(value) {
    return value + DISPLAY_DURATION_ADDTION;
  },
  parse(displayedValue) {
    return Number(displayedValue) - DISPLAY_DURATION_ADDTION;
  }
};